var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 38,
    height: 38,
    rx: 19,
    stroke: "#1B4458",
    strokeOpacity: 0.1,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 19C14.7348 19 14.4804 19.1054 14.2929 19.2929C14.1054 19.4804 14 19.7348 14 20C14 20.2652 14.1054 20.5196 14.2929 20.7071C14.4804 20.8947 14.7348 21 15 21H25C25.2652 21 25.5196 20.8947 25.7071 20.7071C25.8946 20.5196 26 20.2652 26 20C26 19.7348 25.8946 19.4804 25.7071 19.2929C25.5196 19.1054 25.2652 19 25 19H15Z",
    fill: "#1B4458",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21H24.6148C24.6376 20.781 24.653 20.5606 24.6607 20.3393C24.6647 20.2264 24.6667 20.1133 24.6667 20C24.6667 19.8867 24.6647 19.7736 24.6607 19.6607C24.653 19.4394 24.6376 19.219 24.6148 19L24 19H16L15.3852 19C15.3624 19.219 15.347 19.4394 15.3393 19.6607C15.3353 19.7736 15.3333 19.8867 15.3333 20C15.3333 20.1133 15.3353 20.2264 15.3393 20.3393C15.347 20.5606 15.3624 20.781 15.3852 21H16H24Z",
    stroke: "none",
    strokeOpacity: 0.5,
    strokeWidth: 21.3333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.55d58602a6e4957861b5ae50918bb70c.svg";
export { ForwardRef as ReactComponent };